import { Box, CircularProgress, Text, VStack } from "@chakra-ui/react";
import { parse } from "date-fns";
import { P, match } from "ts-pattern";
import { useWellLevelsData } from "../../services/projectService";
import { WellLevelsData, getWellLevelsSitesStats } from "../../types/wellLevelsData";
import { useWellLevelsStorageData } from "../../types/wellLevelsForm";
import { WellLevelsGraph } from "../WellLevelsView/WellLevelsGraph/WellLevelsGraph";
import { printWidth } from "../../types/printData";
import { DashboardMapView } from "../DashboardMapView/DashboardMapView";
import { mapSitesFromWellLevelsData } from "../../types/map";

export function WellLevelsPrintGraphsView() {
  const [{ sites, startDate, endDate }] = useWellLevelsStorageData();

  if (sites.length === 0 || !startDate || !endDate) {
    return <div>Something went wrong</div>;
  }

  return (
    <GraphsViewContainer
      sites={sites}
      startDate={parse(startDate, "yyyy-MM-dd", new Date())}
      endDate={parse(endDate, "yyyy-MM-dd", new Date())}
    />
  );
}

function GraphsViewContainer({ sites, startDate, endDate }: { sites: string[]; startDate: Date; endDate: Date }) {
  const query = useWellLevelsData(startDate, endDate, sites);

  return match(query)
    .with({ isLoading: true }, () => <CircularProgress isIndeterminate color="brand.400" />)
    .with({ isError: true }, () => <Text color="red">Error loading data</Text>)
    .with({ data: P.nullish }, () => <></>)
    .otherwise(({ data }) => <GraphsView data={data} sites={sites} />);
}

function GraphsView({ data, sites }: { data: WellLevelsData; sites: string[] }) {
  const stats = getWellLevelsSitesStats(sites, data);
  return (
    <VStack>
      <Box flex={1} width={printWidth}>
        <DashboardMapView
          mapSites={mapSitesFromWellLevelsData(data.coordinates, stats)}
          colorContext="wellLevels"
        ></DashboardMapView>
      </Box>
      <Box flex={1} width={printWidth}>
        <WellLevelsGraph wellLevelsData={data} sites={sites} />
      </Box>
    </VStack>
  );
}
